import React, { useState } from 'react';
import adminApi from '../utils/adminApi';
import toast from 'react-hot-toast';

export default function AdminLogin({ onSuccess }) {
  const [key, setKey] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    sessionStorage.setItem('evapp_admin_key', key);
    try {
      await adminApi.get('/admin/stats');
      onSuccess();
    } catch (_) {
      sessionStorage.removeItem('evapp_admin_key');
      toast.error('Invalid admin key');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--navy)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 52, height: 52, borderRadius: 14,
            background: 'linear-gradient(135deg, #00D4AA, #0099FF)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 26, margin: '0 auto 14px',
          }}>🛠️</div>
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>Admin Panel</h1>
          <p style={{ fontSize: 13, color: 'var(--text-3)', marginTop: 4 }}>ChargeSure internal dashboard</p>
        </div>
        <div style={{ background: 'var(--slate)', border: '1px solid var(--border)', borderRadius: 16, padding: '28px 24px' }}>
          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div>
              <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 6 }}>Admin Key</label>
              <input
                type="password" required placeholder="Enter admin key"
                value={key} onChange={e => setKey(e.target.value)}
                style={{
                  width: '100%', padding: '11px 13px', borderRadius: 9,
                  background: 'var(--navy)', border: '1px solid var(--border-2)',
                  color: 'var(--text-1)', fontSize: 14, fontFamily: 'Inter, sans-serif',
                }}
              />
            </div>
            <button type="submit" disabled={loading} style={{
              padding: '12px 0', borderRadius: 10, border: 'none',
              background: 'var(--teal)', color: 'var(--navy)',
              fontWeight: 700, fontSize: 14, cursor: 'pointer',
              opacity: loading ? 0.7 : 1,
            }}>
              {loading ? 'Verifying…' : 'Access Dashboard'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
